import React, { memo } from "react";

const TriangleArrowIcon: React.FC = memo(() => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
    >
      <path
        d="M0.807433 3H11.1926C11.911 3 12.2702 3.86778 11.7617 4.37634L6.57112 9.57093C6.2563 9.88575 5.7437 9.88575 5.42888 9.57093L0.23833 4.37634C-0.270231 3.86778 0.0889903 3 0.807433 3Z"
        fill="currentColor"
      />
    </svg>
  );
});

export { TriangleArrowIcon };
